module.exports = __webpack_public_path__ + "fonts/NouvelR-Regular.b1bbeef5.ttf";